module.exports = __webpack_public_path__ + "img/5.b071223c.png";